import nextI18nextConfig from '~/next-i18next.config'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { GetServerSideProps, NextPage } from 'next'
import { DependencyInjector } from '~/injector/dependency.injector'
import { HtmlPageMetaContextService } from '~/components/HtmlPageMeta/HtmlPageMetaContextService'
import { GalleriesPageProps } from '~/components/GalleriesPage'
import { ProfileRepositoryInterface } from '~/modules/Profile/ProfileRepositoryInterface'
import { ListUserProfiles } from '~/modules/Profile/ListUserProfiles'
import { MarketGalleriesPage } from '~/components/MarketPages/GalleriesPage'
import { fromGalleriesPagePropsToViewModel } from '~/modules/PresentationAdapters/GalleriesPageAdapter'
import { UserProfile } from '~/modules/Profile/UserProfile'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const locale = context.locale ? context.locale : nextI18nextConfig.i18n.defaultLocale
  const htmlPageMetaContextService = new HtmlPageMetaContextService(context)
  const dependencyInjector = DependencyInjector.getInstance()
  const profileRepository: ProfileRepositoryInterface = dependencyInjector.resolve('ProfileRepositoryInterface')
  const listUserProfiles = new ListUserProfiles(profileRepository)
  let profiles: UserProfile[] = []

  try {
    profiles = await listUserProfiles.listWithGalleryAndTrophies()
  } catch (exception: unknown) {
    console.error('Failed to load gallery profiles', exception)
  }

  return {
    props: {
      profiles: JSON.parse(JSON.stringify(profiles)),
      htmlPageMetaContextProps: htmlPageMetaContextService.getProperties(),
      ...await serverSideTranslations(locale, [
        'user_tos',
        'app_menu',
        'footer',
        'galleries',
      ]),
    },
  }
}

const GalleriesRoutePage: NextPage<GalleriesPageProps> = (props) => {
  return <MarketGalleriesPage viewModel={ fromGalleriesPagePropsToViewModel(props) } />
}

export default GalleriesRoutePage
